import React from "react";
import { Grid, Paper, Button, Typography } from "@material-ui/core";
import { LocalizationContext } from "../../../core/localization/Localization";
import { MonthlyTradingReportFilter } from "../../../data/reports/monthlyTrade/types";
import { useAuth } from "../../../data/auth/hooks";
import { DisplayDrawerContext } from "../../../layout/DisplayDrawerContext";
import { StringInput } from "../../components/common/StringInput";

export enum MTRFilterEditorType {
  Basic,
  Extended,
}

interface MTRFilterEditorProps {
  filter: MonthlyTradingReportFilter;
  editFilter: (prop: keyof MonthlyTradingReportFilter, value: any) => void;
  save: (numofmonths: number) => void;
  reset: () => void;
  type: MTRFilterEditorType;
}

export const MTRFilterEditor: React.FunctionComponent<MTRFilterEditorProps> = ({
  filter,
  editFilter,
  save,
  type,
  reset,
}) => {
  const showWithDrawer = React.useContext(DisplayDrawerContext);
  const { getString } = React.useContext(LocalizationContext);
  const [auth] = useAuth();

  const handleChange = React.useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      editFilter(event.target.name as any, Number(event.target.value));
    },
    [editFilter]
  );

  return (
    <Paper
      style={{
        paddingLeft: "70px",
        paddingRight: "70px",
        paddingTop: "15px",
        paddingBottom: "15px",
      }}
    >
      <Grid container direction="column" spacing={6}>
        <Grid item container direction="row" spacing={2}>
          <StringInput<MonthlyTradingReportFilter>
            type="number"
            property="numofmonths"
            item={filter}
            onChange={handleChange}
            label={getString("monthlyNumofmonths")}
          />
        </Grid>

        <Grid item container direction="row-reverse" spacing={2}>
          <Grid item>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                if (filter.numofmonths) {
                  save(filter.numofmonths);
                }
                showWithDrawer(undefined);
              }}
            >
              {getString("orderFilterConfirm")}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};
